import {delegate} from '@js/util/delegate.js';

document.addEventListener('click', delegate('[data-search-dialog-item="toggle"]', e => {
  const dialog = document.querySelector('[data-search-dialog]');

  dialog.showModal();
}));
